import { defineSlotRecipe } from '@chakra-ui/react';
import { nativeSelectAnatomy } from '@chakra-ui/react/anatomy';

import inputRecipe from '../basic/input';

export default defineSlotRecipe({
  slots: nativeSelectAnatomy.keys(),
  defaultVariants: {
    variant: 'outline',
  },
  variants: {
    variant: {
      outline: {
        field: {
          ...inputRecipe.variants!.variant.outline,
          pl: 4,
          pr: 8,
          py: '5px !important',
        },
        indicator: {
          color: 'black',
        },
      },
    },
  },
});
